export default __webpack_public_path__ + "ecf6bf771823a9a58dc1db4dbe380c2f.png";